<template>
    <div class="home" :style="{height:screenHeight + 'px',width:screenWidth +'px'}">
        <div class="theme">
            <img src="../../static/home.png" mode="top left" style="width:100%;height:100%">
            <van-swipe autoplay="2000" lazy-render class="content" :show-indicators="false" :touchable="false">
                <van-swipe-item @click="startGame" v-for="item in imgList" :key="item.id">
                    <div class="roleBackground"></div>
                    <img :src="item.img" alt="" style="width: 100%;height: 70%;position:absolute;top: 0;">
                    <div class="fl_text"><i>[</i> {{item.role}} <i>]</i></div>
                    <div class="introduceBackground">
                    </div>
                    <div class="introduceText">{{item.introduce}}</div>
                </van-swipe-item>
            </van-swipe>
        </div>
    </div>
</template>

<script>
import { Swipe, SwipeItem } from 'vant';
export default {
    components: {
        [Swipe.name]: Swipe,
        [SwipeItem.name]: SwipeItem,
    },
    data() {
        return {
            currentIndex: 0,
            timer:null,
            imgList: [
                {
                    id: 0,
                    role: '滚京团',
                    img: require('../../static/role1.png'),
                    introduce:'采用糯米粉和生粉和到团，再分成若干小团，搓圆，放入沸水中煮熟。捞出，放入熟豆粉（炒熟的黄豆或玉米碾成粉）、熟芝麻、红糖拌匀成为“豆黄”中反复粘沾，做成粘粉带糖滚芝麻的滚京团。'

                },
                {
                    id: 1,
                    role: '编草扇',
                    img: require('../../static/role21.png'),
                    introduce:'采用九板桥村当地所产的草本植物作原料，选取草本植物中柔韧的秆、皮、芯、叶、根，竖经横纬，纯手工通过编、结、辫、扣、扎、绞、缠、网、串、盘等丰富的手法和编结技法，编织成草扇。'
                },
                {
                    id: 2,
                    role: '砌墙磡',
                    img: require('../../static/role3.png'),
                    introduce:'河边的石砌墙，叫做“石磡”，石磡按照纵联砌置法构筑而成，或设置石耳，用来拴小船，或设有埗头，方便村民挑水、洗涤，以及运载货物时上下河涌。而岸上每条巷口对开会或设有穿过石砌墙的用于排放污水的水渠口。'
                },
                {
                    id: 3,
                    role: '凿碗字',
                    img: require('../../static/role4.png'),
                    introduce:'先将字样描写在碗底，通过一把凿子和一把锤子，依笔迹的每一笔横竖撇捺折笔划都凿上一个个连续的的洞，按指定字样凿在碗底后，再用破布蘸墨一擦，然后把字的周围清洗干净，墨迹就深入到凿出来的字上了，永远不会褪色。'
                },
            ],
            screenWidth:0,
            screenHeight:0
            
        }
    },
    mounted() {
        // this.startInterval()
        window.screenWidth = document.body.clientWidth;
        window.screenHeight = document.body.clientHeight;
        this.screenWidth = window.screenWidth;
        this.screenHeight = window.screenHeight;

    },
    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer); //关闭
        }
    },
    methods: {
        startGame() {
            this.$router.push('/baigongfeiyi/start')
        },
        startInterval() {
            // 事件里定时器应该先清除在设置，防止多次点击直接生成多个定时器
            clearInterval(this.timer);
            this.timer = setInterval(() => {
                this.currentIndex++;
                if (this.currentIndex > this.imgList.length - 1) {
                    this.currentIndex = 0
                }
            }, 3000)
        },
    }
}
</script>
<style scoped>

    .home {
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;
        opacity: 1;
        position: relative;
    }

    .theme {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        background: transparent url('../../static/homeBackground.png') 0% 0% padding-box;
        background-size: 100%;
    }

    .content {
        width: 80%;
        height: 90%;
        margin-top: 20px;
        box-sizing: border-box;
        position: absolute;
        top: 0;
    }

    .fl_text {
    position: absolute;
    font-size: 3rem;
    margin: 0 auto;
    width: 20px;
    top: 50px;
    left: 50px;
    font-family: 'jxzhuokai';
    display: flex;
    flex-direction: column;
    align-content: center;
}

.roleBackground {
    position: absolute;
    width: 90%;
    height: 60%;
    top: 40px;
    left: 5%;
    background-color: #FFFFFF;
    opacity: 0.7;
    border-radius: 15px;
}

.introduceBackground {
    position: absolute;
    width: 90%;
    height: 17rem;
    bottom: 10rem;
    left: 5%;
    background-color: #FFFFFF;
    opacity: 0.7;
    border-radius: 15px;
}

.introduceText {
    font-family: 'jxzhuokai';
    width: 90%;
    padding: 10px 10px;
    box-sizing: border-box;
    font-size: 1.5rem;
    position: absolute;
    bottom: 11rem;
    left: 5%; 

}
</style>